import React, { useState } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import ConteoCheck from '../../../components/productos/ConteoCheck';
import { grabarConteoProducto } from './ocGrabarConteo';

/**
 * Existencias grandes + ConteoCheck + banner/botón Contar ahora.
 */
const OcStockConteoBlock = ({
  idProducto,
  nombreProducto,
  stockActual,
  stockMinimo,
  diasInventario,
  tieneMovimientosRecientes = false,
  nombreEmpleado = null,
  fechaUltimoMovimiento = null,
  token = null,
  canGrabar = false,
  onUpdated,
  tooltipId,
}) => {
  const [busy, setBusy] = useState(false);
  const stock = stockActual != null ? Number(stockActual) : null;
  const pendiente = !tieneMovimientosRecientes;

  const handleContar = async () => {
    if (!canGrabar || !token || !idProducto || busy) return;
    setBusy(true);
    try {
      const result = await grabarConteoProducto({
        token,
        idProducto,
        nombreProducto,
        stockActual: stock ?? 0,
      });
      if (result && onUpdated) onUpdated(result);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-2 rounded-xl bg-slate-900 text-emerald-300 px-3 py-1.5 shadow-sm">
          <span className="text-[10px] font-bold uppercase tracking-wide text-slate-400">
            Existencias
          </span>
          <span className="text-base font-black tabular-nums">
            {stock != null ? stock : '—'}
          </span>
          {stockMinimo != null && Number(stockMinimo) > 0 && (
            <span className="text-[11px] font-semibold text-slate-400">
              / mín {stockMinimo}
            </span>
          )}
        </span>
        {diasInventario != null && (
          <span className="text-xs font-semibold text-slate-600 bg-white border border-slate-200 rounded-lg px-2 py-1">
            ~{diasInventario}d inventario
          </span>
        )}
        {idProducto != null && (
          <ConteoCheck
            show={tieneMovimientosRecientes}
            empleado={nombreEmpleado}
            fecha={fechaUltimoMovimiento}
            tooltipId={tooltipId || `oc-conteo-${idProducto}`}
          />
        )}
      </div>

      {pendiente && idProducto != null && (
        <div className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-2 text-amber-950 space-y-2">
          <p className="text-xs font-semibold leading-snug flex items-start gap-1.5">
            <FaExclamationTriangle className="shrink-0 mt-0.5" />
            Hay que contar este producto antes de pedirlo — el stock del sistema puede estar desactualizado.
          </p>
          {canGrabar && token && (
            <button
              type="button"
              disabled={busy}
              onClick={handleContar}
              className="h-9 px-3 rounded-lg bg-amber-600 text-white text-xs font-bold disabled:opacity-50"
            >
              {busy ? 'Guardando…' : 'Contar ahora'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default OcStockConteoBlock;
